import { useCallback } from "react"
import { Str_SelectShiftOutMember, Str_ShiftOutFail, Str_ShiftOutSucc } from "../../language/string_res"
import { TopicUserListRender } from "../Chat/TopicUsers"
import { MainNavProps } from "../navigation/main/MainParamList"
import { hideLoading, showLoading } from "../../components/Loading"
import * as ImSdk from "../../../imsdk/api";
import { showToast } from "../../components/Toast"
import globalEventBus from "../../utils/EventBus"
export const RemoveUserModal = ({ navigation, route }: MainNavProps<'RemoveUserModal'>) => {
    const label = route.params.label
    const users = route.params.users ?? []

    //移除标签的成员
    const onRemoveUserSubmit = useCallback((uids: number[]) => {
        showLoading()
        ImSdk.getInstance().DelLabelUids(label, uids).then((r) => {
            hideLoading()
            if (!r.error) {
                showToast(Str_ShiftOutSucc)
                globalEventBus.emit("DelLabelUser", { label: label, uids: uids })
                navigation.goBack()
            } else {
                showToast(r.error || Str_ShiftOutFail)
            }
        })
    }, [label])
    return (
        <TopicUserListRender
            users={users}
            backIcon={require('../../assets/image/icon_close.png')}
            backIconStyle={{ width: 30, height: 30 }}
            title={Str_SelectShiftOutMember}
            onClose={() => { navigation.goBack() }}
            onSubmit={onRemoveUserSubmit}
            hasRadio={true} />
    )
}